import { render, staticRenderFns } from "./SignupWithTokenPage.vue?vue&type=template&id=766120b6&scoped=true"
import script from "./SignupWithTokenPage.vue?vue&type=script&lang=js"
export * from "./SignupWithTokenPage.vue?vue&type=script&lang=js"
import style0 from "./SignupWithTokenPage.vue?vue&type=style&index=0&id=766120b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766120b6",
  null
  
)

export default component.exports